import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  BEACON_CHART_SPACING,
  BEACON_PRO_PAGE_MARGIN_BOTTOM
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { PaidSearchTopicsKeyMetricCards } from '../Topics/PaidSearchTopicsKeyMetricCards';
import { PaidSearchTopicsMultiMetricSplineChart } from '../Topics/PaidSearchTopicsMultiMetricSplineChart';
import { PaidSearchTopicsDoubleOptionBarChart } from '../Topics/PaidSearchTopicsDoubleOptionBarChart';
import { PaidSearchTopicsGrid } from '../Topics/PaidSearchTopicsGrid';

/**
 * Paid search tab for topics or topic gropus
 */
export function TopicOrTopicGroupPage() {
  return (
    <Flex flexDirection="column" gap={BEACON_CHART_SPACING} marginBottom={BEACON_PRO_PAGE_MARGIN_BOTTOM}>
      <PaidSearchTopicsKeyMetricCards />
      <PaidSearchTopicsDoubleOptionBarChart />
      <PaidSearchTopicsMultiMetricSplineChart />
      <PercentTotalTrafficSplineChart trafficType="paidTraffic" />
      <PaidSearchTopicsGrid />
    </Flex>
  );
}
